import { Rocket } from "lucide-react";
import { GO_LIVE_BLOCK, GO_LIVE_PREREQUISITES, getGoLiveCompletion } from "../config/goLive";

const STATUS_UI = {
  completed: { label: "Listo", className: "bg-brand-primary/15 text-brand-primary" },
  in_progress: { label: "En curso", className: "bg-amber-100 text-amber-800" },
  pending: { label: "Pendiente", className: "bg-brand-soft text-brand-dark/55" },
};

export default function CmsGoLivePanel() {
  const { completed, total } = getGoLiveCompletion();

  return (
    <section className="bg-white rounded-[28px] border border-brand-soft p-6 space-y-5 max-w-3xl">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-brand-primary text-white flex items-center justify-center shrink-0">
          <Rocket size={18} />
        </div>
        <div>
          <h3 className="font-display font-black text-xl text-brand-dark">{GO_LIVE_BLOCK.title}</h3>
          <p className="text-sm text-brand-dark/60 mt-1 leading-relaxed">{GO_LIVE_BLOCK.summary}</p>
          <p className="text-xs text-brand-dark/45 mt-2">
            {completed}/{total} condiciones listas · {GO_LIVE_BLOCK.note}
          </p>
        </div>
      </div>
      <ul className="space-y-3">
        {GO_LIVE_PREREQUISITES.map((item) => {
          const ui = STATUS_UI[item.status] || STATUS_UI.pending;
          return (
            <li
              key={item.id}
              className="rounded-2xl border border-brand-soft px-4 py-3 flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4"
            >
              <span
                className={`shrink-0 self-start rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest ${ui.className}`}
              >
                {ui.label}
              </span>
              <div className="min-w-0">
                <p className="font-display font-bold text-brand-dark">{item.title}</p>
                <p className="text-sm text-brand-dark/60 mt-0.5 leading-relaxed">{item.description}</p>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
